module.exports = __webpack_public_path__ + "static/wintersense-landscape-vibrant-wide.0c21239d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/WinterLanding/wintersense-landscape-vibrant-wide.jpg
// module id = 467
// module chunks = 35783957827783